import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { StartRedirectGuard } from './core/start-redirect.guard';

const routes: Routes = [
  { path: '', redirectTo: 'start', pathMatch: 'full' },
  {
    // New flow lives at /apply. Always available — but for tenants that have
    // useNewStepper=true, navigating to /start will be redirected here.
    path: 'apply',
    loadChildren: () => import('./apply/apply.module').then(m => m.ApplyModule)
  },
  {
    path: 'start',
    canActivate: [StartRedirectGuard],
    loadChildren: () => import('./start/start.module').then(m => m.StartPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
